var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { GetOutskirtBuildingBundle } from "../assetBundles/outskirts/GetOutskirtBuildingBundle";
import { selectBalancingOutskirt, selectBalancingOutskirts, } from "../balancingSelectors/selectBalancingOutskirts";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { EventType } from "../features/balancing/types/BalancingCore";
import { selectActiveDiscountEventInfoByEventType, selectThemedEventBuildingName, selectThemedEventNextBuildingBundle, } from "./selectEventInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectOutskirtBuildingInfo = function (state, id) {
    var balancing = selectBalancingOutskirt(id);
    var proto = state.outskirtsInfo.outskirt.find(function (val) { return val.typeId === id; });
    return {
        balancing: balancing,
        proto: proto,
    };
};
export var selectOutskirtBuildingVisualLevel = function (state, id) {
    var info = selectOutskirtBuildingInfo(state, id);
    return selectOutskirtBuildingVisualLevelFromInfo(info);
};
export var selectOutskirtBuildingVisualLevelFromInfo = function (info) {
    var buildingStage = selectOutskirtBuildingStage(info);
    return buildingStage.visualLevel;
};
export var selectOutskirtBuildingLevel = function (state, id) {
    var info = selectOutskirtBuildingInfo(state, id);
    return selectOutskirtBuildingLevelFromInfo(info);
};
export var selectOutskirtBuildingLevelFromInfo = function (info) {
    var buildingStage = selectOutskirtBuildingStage(info);
    return buildingStage.level;
};
export var selectOutskirtBuildingStage = function (info) {
    var stages = info.balancing.outsideBuildingStage;
    if (info.proto) {
        var stageId = info.proto.stage || 1;
        if (stages.length >= stageId) {
            return stages[stageId - 1];
        }
    }
    return stages[0];
};
export var selectOutskirtBuildingAccessible = function (state, id) {
    var balancingOutskirtBuilding = selectBalancingOutskirt(id);
    var unlockLevel = balancingOutskirtBuilding
        ? balancingOutskirtBuilding.unlockLevel
        : Number.MAX_VALUE;
    var playerLevel = selectPlayerLevel(state);
    return playerLevel >= unlockLevel;
};
export var selectOutskirtBuildingMaxLevel = function (state, id) {
    var outskirtBuildingStageInfo = selectOutskirtBuildingInfo(state, id).balancing
        .outsideBuildingStage;
    return outskirtBuildingStageInfo[outskirtBuildingStageInfo.length - 1].level;
};
export var selectOutskirtBuildingBundleOnLoad = function (state) {
    var allOutskirtBuildings = Array.from(selectBalancingOutskirts().values());
    return allOutskirtBuildings.reduce(function (acc, info) {
        var id = info.id;
        var currentLevel = selectOutskirtBuildingVisualLevel(state, id);
        var outskirtBuildingLevel = selectOutskirtBuildingLevel(state, id);
        var nextBundle = {};
        if (id === IdOutskirtBuildings.ThemedEvent) {
            nextBundle = selectThemedEventNextBuildingBundle(state);
        }
        else if (outskirtBuildingLevel) {
            var nextBuildingStage = outskirtBuildingLevel + 1;
            var nextBuildingInfo = {
                balancing: selectBalancingOutskirt(id),
                proto: {
                    stage: nextBuildingStage,
                },
            };
            var nextLevel = selectOutskirtBuildingVisualLevelFromInfo(nextBuildingInfo);
            nextBundle = __assign({}, selectOutskirtBuildingBundleByBuildingId(state, id, nextLevel, true));
        }
        var currentBundle = selectOutskirtBuildingBundleByBuildingId(state, id, currentLevel);
        var currentUnlockedBundle = selectOutskirtBuildingBundleByBuildingId(state, id, currentLevel, true);
        return __assign({}, acc, currentBundle, currentUnlockedBundle, nextBundle);
    }, {});
};
export var selectOutskirtBuildingBundleByBuildingId = function (state, outskirtBuildingId, level, isAccessible, buildingName) {
    if (isAccessible === void 0) { isAccessible = false; }
    var _a;
    var isBuildingAccessible = isAccessible
        ? isAccessible
        : selectOutskirtBuildingAccessible(state, outskirtBuildingId);
    if (outskirtBuildingId === IdOutskirtBuildings.ThemedEvent && !buildingName) {
        buildingName = selectThemedEventBuildingName(state);
    }
    var bundle = GetOutskirtBuildingBundle(outskirtBuildingId, level, isBuildingAccessible, buildingName);
    if (bundle && bundle.data.length > 0) {
        return _a = {},
            _a[getOutskirtBuildingBundleKey(bundle, outskirtBuildingId, level)] = bundle.data,
            _a;
    }
    return {};
};
export var selectOutskirtBuildingCurrentLevel = function (state, id) {
    var outskirtInfo = selectOutskirtBuildingInfo(state, id);
    var proto = outskirtInfo.proto;
    return proto ? proto.stage || 1 : 1;
};
export var selectOutskirtBuildingImprovementInfo = function (state, outskirtId, improvementId) {
    var outskirtInfo = selectOutskirtBuildingInfo(state, outskirtId);
    var proto = outskirtInfo.proto;
    var outskirtImprovements = proto ? proto.improvement || [] : [];
    return outskirtImprovements.find(function (improvementType) { return improvementType.improvementId === improvementId; });
};
export var selectSelectedOutskirtBuildingId = function (state) {
    return state.outskirtsInfo.selectedOutskirtBuildingId;
};
var getOutskirtBuildingBundleKey = function (bundle, outskirtBuildingId, level) {
    return bundle.id || "outskirt-" + outskirtBuildingId + "-" + level;
};
export var selectOutskirtExternalBarnHasDiscount = function (state) {
    return selectActiveDiscountEventInfoByEventType(state, EventType.OutskirtDiscount) != undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectOutskirtBuildingInfo.ts
// module id = 70
// module chunks = 3